import { Dispatch, SetStateAction } from "react";

export enum LibraryTabEnum {
	DOCUMENT = "document",
	LINK = "link",
}

export const LIBRARY_TABS = [
	{
		label: "Tài liệu",
		value: LibraryTabEnum.DOCUMENT,
	},
	{
		label: "Liên kết",
		value: LibraryTabEnum.LINK,
	},
];

export interface ILibraryManagementDialogProps {
	open: boolean;
	onCloseDialog: () => void;
	selectResourceId: string | null;
	setSelectResourceId: Dispatch<SetStateAction<string | null>>;

	isMultiple: boolean;
	multipleResources: string[];
	setMultipleResources: Dispatch<SetStateAction<string[]>>;
}

export interface IPublishedSuccessDialogProps {
	open: boolean;
	onCloseDialog: () => void;
}
